import { Base } from "ui/Scripts/source/framework/base";
import { IUnitNodeSavePermission, UnitNodeSavePermission } from "./unitNodeSavePermission";

export interface IUnitNodeSave {
    id: string;
    permissions: IUnitNodeSavePermission[];
}

export class UnitNodeSave implements IUnitNodeSave {
    id: string;
    permissions: UnitNodeSavePermission[];

    constructor();
    constructor(obj: IUnitNodeSave);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.permissions = Base.getTypedArray(obj ? obj.permissions : null, UnitNodeSavePermission);
    }

    static getSortedJsonUnitNodeSaves(src: IUnitNodeSave[]): IUnitNodeSave[] {
        const result = src.slice(0);
        result.sort((a: IUnitNodeSave, b: IUnitNodeSave) => {
            if ((a === null || a === undefined) && (b === null || b === undefined)) return 0;
            if (a === null || a === undefined) return 1;
            if (b === null || b === undefined) return -1;
            if ((a.id === null || a.id === undefined) && (b.id === null || b.id === undefined)) return 0;
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
        });
        return result;
    }
}